import React, { useState } from "react";
import { X } from "lucide-react";
import Step1Contact from "./steps/Step1Contact";
import Step2VerifyContact from "./steps/Step2VerifyContact"
import Step3Names from "./steps/Step3Names"
import { Backdrop, Modal, CloseButton, FormContainer } from "../shared/FormLayout";
import Step4Birthdate from "./steps/Step4Birthdate";
import Step5Gender from "./steps/Step5Gender";
import Step6Password from "./steps/Step6Password";
import Step7Agreement from "./steps/Step7Agreement";
import Sign8Roles from "./steps/Sign8Roles";
import Step9ProfilePic from "./steps/Step9ProfilePic";
import Step10Interest from "./steps/Step10Interest";
import Step11EduLevels from "./steps/Step11EduLevels";
import Step12HighestEdu from "./steps/Step12HighestEdu";
import Step13CareerAmbition from "./steps/Step13Ambition";

export default function SignupModal({ onClose }) {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});

  const handleSubmit = (finalData) => {
  console.log("FINAL SIGNUP DATA:", finalData);
};

  const nextStep = (data) => {
    setFormData(prev => ({ ...prev, ...data }));
    setStep(prev => Math.min(prev + 1, 12));
  };
  const prevStep = () => setStep(prev => Math.max(prev - 1, 1));
  const steps = {
    1: <Step1Contact onNext={nextStep} />,
    2: <Step2VerifyContact onNext={nextStep} onBack={prevStep}/>,
    3: <Step3Names onNext={nextStep} onBack={prevStep} />,
    4: <Step4Birthdate onNext = {nextStep} onBack={prevStep}/>,
    5: <Step5Gender onNext = {nextStep} onBack={prevStep}/>,
    6: <Step6Password onNext={nextStep} onBack={prevStep}/>,
    7: <Step10Interest onNext={nextStep} onBack={prevStep}/>,
    8: <Step9ProfilePic onNext={nextStep} onBack={prevStep}/>,
    9: <Step11EduLevels onNext={nextStep} onBack={prevStep}/>,
    10: <Step12HighestEdu onNext={nextStep} onBack={prevStep}/>,
    11: <Step13CareerAmbition onNext={nextStep} onBack={prevStep}/>,
    12: (
    <Step7Agreement
      formData={formData}
      onBack={prevStep}
      onSubmit={handleSubmit}
    />
  ),

  };

  return (
    <Backdrop>
        <FormContainer>
      <Modal onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={onClose}>
            <X size={25} />
          </CloseButton>
        {steps[step]}
      </Modal>
      </FormContainer>
    </Backdrop>
  );
}
